import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

export default data => {
  return {
    id: get(data, 'mcb2Id', null),
    title: get(data, 'mcb2Title', null),
    banner: data.mcb2Banner.map(item => {
      return {
        heading: get(item, 'heading', null),
        text: get(item, 'text', null),
        image: get(item, 'mcb2Image', null) ? refactorRespImg(get(item, 'mcb2Image', null), [{
          size: 'default',
          key: 'image_size_375x451',
        },{
          size: 'md',
          key: 'image_size_760x516',
        },{
          size: 'lg',
          key: 'image_size_1600x650',
        }]): null,
        video: get(item, 'video', null),
        link: {
          'title': get(item, 'link.title', null),
          'href': get(item, 'link.url', null),
          'tagret': get(item, 'link.target', null),
          "assignedDomains": [
            "jayco.com.au",
            "jayco.co.nz",
            "AU-dealers",
            "NZ-dealers"
          ]
        },
      }
    })
  }
}
